import ResolveLoader from './ResolveLoader.component';

export default ResolveLoader;